import axios from "axios";
import * as config from "../../../app.config";
import { setHeaders } from "../../../utils/basic";
import { useQuery } from "react-query";

import { isObjectEmptyNull } from "../../../utils/basic";

const fetchDdpcr2DGraphById = async (graphVar) => {
    const { plateId, wellId } = graphVar;
    const headerConfig = setHeaders();

    const { data: urlWrapper } = await axios.get(
        `${config.ENDPOINTS["datalake"]}/ddpcr/graph/twod/${plateId}/${wellId}`,
        { headers: headerConfig }
    );
    const { data: graphData } = await axios.get(urlWrapper.signedUrl);
    return graphData;
};

export default function useFetchDdpcr2DGraphData(graphVar) {
    return useQuery(["2DGraph", graphVar], () => fetchDdpcr2DGraphById(graphVar), {

        enabled: !isObjectEmptyNull(graphVar),
        onSuccess: (data) => {
            console.log(data);
        },

    });
}
